export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-thumbnail-480-805534399e53388e2d980d801a14065d.png";